export default "__VITE_ASSET__lThnEBK5__"